import React from 'react';
import { useLoaderData, useNavigation } from 'react-router-dom';
import Apointment from './../../Apointment/Apointment';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import Cheackout from './Cheackout';
import Looading from '../../Shared/Looading/Looading';


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);
console.log(stripePromise)


const Payment = () => {
    const booking = useLoaderData();
    const navigation = useNavigation()
    const { treatment, price, appointmentDate, slot } = booking;
    if(navigation.state === "loading"){
        return <Looading></Looading>

    }
    console.log(booking)
    return (
        <div>
            <div className="">
                <h1 className='text-3xl my-10 text-info font-bold'>Pleace Payment For {treatment}</h1>
                <p className='text-2xl'>Please pay <strong>${price} </strong> for your Apointment on {appointmentDate} at {slot}</p>
            </div>

            <div className="my-12 w-64">
                <Elements stripe={stripePromise}>
                    <Cheackout
                        booking={booking}
                    ></Cheackout>
                </Elements>
            </div>
        </div>

    );
};

export default Payment;